// extracted by mini-css-extract-plugin
export default {"whoWeAreContent":"WhoWeAre_whoWeAreContent__XO-rh","wrapper":"WhoWeAre_wrapper__6JTSv","bg":"WhoWeAre_bg__3rh+S","description":"WhoWeAre_description__1bUvz"};